import React from 'react';
import { Platform } from 'react-native';
import styled from 'styled-components/native';
import AppManifest from '../common/AppManifest';
import { P } from './Typography';

const StyledVersionContainer = styled.View`
  /* flex: 1; */
`;

const StyledVersionBuildText = styled(P)`
  margin-top: 32px;
  font-size: 10px;
  color: #333;
  align-self: center;
`;
const AppVersionInfo: React.FC = () => {
  return (
    <StyledVersionContainer>
      <StyledVersionBuildText color='light' padding={2}>
        App v{AppManifest.version} / Runtime v{AppManifest.runtimeVersion}
        {Platform.OS === 'ios' || Platform.OS === 'android'
          ? ` (Build: ${AppManifest.buildNumber})`
          : ''}
      </StyledVersionBuildText>
    </StyledVersionContainer>
  );
};

export default AppVersionInfo;
